import { BillingTransactionTypeEnum } from '@api/READ_ONLY/billing_api/Api';

const RECORD_TYPE_LABEL_KEYS: Record<BillingTransactionTypeEnum, string> = {
  [BillingTransactionTypeEnum.ClientPayment]: 'collection-from-client',
  [BillingTransactionTypeEnum.ClientCharge]: 'client-charge',
  [BillingTransactionTypeEnum.DoctorPayout]: 'payment-to-doctor',
  [BillingTransactionTypeEnum.CaregiverPayout]: 'payment-to-caregiver',
  [BillingTransactionTypeEnum.ProviderPayout]: 'payment-to-provider',
  [BillingTransactionTypeEnum.DoctorAccrual]: 'doctor-earnings',
  [BillingTransactionTypeEnum.CaregiverAccrual]: 'caregiver-earnings',
  [BillingTransactionTypeEnum.ProviderAccrual]: 'provider-earnings',
  [BillingTransactionTypeEnum.CashCollection]: 'cash-collected',
  [BillingTransactionTypeEnum.CashDeposit]: 'cash-deposit',
};

/**
 * How a billing movement is named, wherever it is listed.
 *
 * Its own module rather than living beside the ledger table: the client card's
 * billing drawer lists the same movements and must name them identically, and
 * importing the table to get one function pulls the whole data-grid in with it.
 * An unknown type shows its raw value rather than another type's name.
 */
export const getRecordTypeLabelKey = (recordType: BillingTransactionTypeEnum): string =>
  RECORD_TYPE_LABEL_KEYS[recordType] ?? recordType;
